import { createSlice } from '@reduxjs/toolkit'
import { PrefixType } from '../../interfaces/Prefix'
import { FilterState } from '../../interfaces/FilterState'

const filtersSlice = (prefix: PrefixType, initialState?: FilterState) =>
    createSlice({
        name: `${prefix}/filters`,
        initialState,
        reducers: {
            saveFilters: (state, action): FilterState => action.payload,
            resetFilters: () => initialState,
        },
    })

const filters = (prefix: PrefixType, initialState: FilterState) => filtersSlice(prefix, initialState).reducer

export const filtersActions = (prefix: PrefixType) => filtersSlice(prefix).actions

export default filters
